module.exports = "9f38b67a64a1b328b9785f8a392c3bf3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/bg2.png
// module id = 69
// module chunks = 0